module.exports = __webpack_public_path__ + "static/media/1.37b7271a.jpeg";